define.alias("shared/components/shared/video-player/controls", "media/components/shared/video-player/controls");